import { useQuery } from "react-query";
import { namesUseQuery } from "../../utils/constants";
import { useContext } from "react";
import CurrentUserContext from "../../contexts/CurrentUserContext";
import { StoresService } from "../../services/StoresService";

export function useCountStores() {
  const { db } = useContext(CurrentUserContext);

  const { data, isLoading } = useQuery(
    [namesUseQuery?.GET_COUNT_PETS],
    () => StoresService.getCountStoresRegisters(db),
    {
      onError: (error) => {
        console.log(error);
      },
    }
  );

  return {
    data: data,
    isLoading,
  };
}
